import { Component, Input } from '@angular/core';

@Component({
  selector: 'carrer',
  templateUrl: 'carrer.html'
})
export class CarrerComponent {

  @Input () adreca: string;
  @Input () tipo: string;
  @Input () regim: string;
  @Input () urlimg: string;
  @Input () espai: string;
  constructor() {}

}



// WEBPACK FOOTER //
// ./src/components/carrer/carrer.ts